import React, { useRef, useState, useEffect } from "react";
import Textbox from "carbon-react/lib/__experimental__/components/textbox";
import StepTitle from "../../../../common/stepTitle/StepTitle";
import DialogConfirmButtons from "../../../../common/dialogConfirmButtons/DialogConfirmButtons";
import SuccessMessage from "../../../../messages/SuccessMessage";
import ConfirmDialog from "../../../../common/confirmDialog/ConfirmDialog";

const EnterCodeStep = ({
  user,
  busy,
  state,
  onStateChanged,
  onCancel,
  onCompleted,
}) => {
  const validationCodeInputRef = useRef(null);
  const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);

  useEffect(() => {
    //  Set focus to the validation code input element
    if (!busy && isAValidFunc(validationCodeInputRef?.current?.focus)) {
      validationCodeInputRef.current.focus();
    }
  }, [busy]);

  const isAValidFunc = (func) => {
    return func && typeof func === "function";
  };

  const onCancelClicked = () => {
    if (isAValidFunc(onCancel)) onCancel();
  };

  const performMfaEnrollmentDelete = () => {
    if (!validateStep()) return;
    if (isAValidFunc(onCompleted)) onCompleted();
  };

  const validateStep = () => {
    let result = true;
    if (!validateVerificationCode()) result = false;
    return result;
  };

  const validateVerificationCode = () => {
    const valid =
      state.verificationCode && state.verificationCode.length > 0
        ? true
        : false;
    updateState(() => {
      state.verificationCodeValid = valid;
    });
    return valid;
  };

  const onConfirmDeleteCancel = () => {
    setConfirmDeleteOpen(false);
  };

  const onConfirmDeleteContinue = async () => {
    setConfirmDeleteOpen(false);
    await performMfaEnrollmentDelete();
  };

  const verificationCodeWarningAttributes = {
    hasWarning: true,
    inputIcon: "warning",
    tooltipMessage: "Please enter a valid code",
  };

  const onVerificationCodeChanged = (code) => {
    const sanitizedCode = code && code.length > 0 ? code.trim() : "";
    updateState(() => {
      state.verificationCode = sanitizedCode;
      state.verificationCodeValid = true;
    });
  };

  const updateState = (mutateState) => {
    if (isAValidFunc(mutateState)) mutateState();
    onStateChanged({ ...state });
  };

  const verificationCodeInput = (
    <div className="delete-mfa-enrollment-verification-code">
      <Textbox
        id="delete-mfa-enrollment-verification-code"
        label="Verification code"
        disabled={busy}
        value={state?.verificationCode}
        inputRef={(e) => {
          validationCodeInputRef.current = e?.current;
        }}
        onChange={(e) => {
          onVerificationCodeChanged(e.target.value);
        }}
        onBlur={validateVerificationCode}
        {...(!state.verificationCodeValid
          ? verificationCodeWarningAttributes
          : {})}
      />
    </div>
  );

  const buttons = (
    <DialogConfirmButtons
      appearBusy={busy}
      confirmBtnEnabled={true}
      confirmBtnLabel="Delete"
      onConfirm={() => {
        setConfirmDeleteOpen(true);
      }}
      onCancel={onCancelClicked}
    />
  );

  const confirmDeletion = (
    <ConfirmDialog
      open={confirmDeleteOpen}
      prompt="Are you sure you want to delete this MFA enrollment? This action can’t be reversed."
      confirmBtnLabel="Delete"
      onCancel={onConfirmDeleteCancel}
      onConfirm={onConfirmDeleteContinue}
    />
  );

  return (
    <div id="enter-code-step" className="delete-mfa-enrollment-enter-code-step">
      <div className="-access-step-body">
        <SuccessMessage
          className="code-sent-success-message"
          message={`Verification code was sent to ${user?.email}`}
        />
        <StepTitle title="Enter verification code" />
        {verificationCodeInput}
      </div>
      {buttons}
      {confirmDeletion}
    </div>
  );
};

export default EnterCodeStep;
